import React,{useEffect} from 'react'
import { Link } from 'gatsby'
import SocialIcons from './socialIcons'
import Logo from './imageLogo'
import MenuButton from './menu-button'
import styled from "styled-components"

const TopNavBar = ({ isNavOpen, toggleNavOpen }) => {
  return(
  <div className="w3-row">
    <div>
      <div id="home" className="topnav w3-row">
        <div className="w3-third">
          <ul className="nav-links">
            <li className="internal-links w3-button hamburger-menu-button">
              <MenuButton isNavOpen={isNavOpen} toggleNavOpen={toggleNavOpen} />
            </li>
            <li className="internal-links w3-button">
              <Link className="w3-margin-right w3-margin-left" to="/">
                Home
              </Link>
            </li>
            <li className="internal-links w3-button">
              <Link className="w3-margin-right w3-margin-left" to="/about/">
                About
              </Link>
            </li>
          </ul>
        </div>
        <div className="w3-third">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <div className="w3-third  ">
          <ul className="nav-links">
            <li className="internal-links w3-right social-icons-topnav">
              <SocialIcons />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  )
}

export default TopNavBar
